export const categories = [
  {
    slug: 'ding-yi',
    name: '定义与含义',
    description: 'NTR的基本定义、核心概念与相关术语解析',
    icon: 'ri-book-read-line',
    color: 'accent',
  },
  {
    slug: 'qi-yuan',
    name: '起源与发展',
    description: 'NTR的历史起源、发展脉络与演变过程',
    icon: 'ri-history-line',
    color: 'secondary',
  },
  {
    slug: 'wen-hua',
    name: '文化背景',
    description: 'NTR在日本二次元文化中的地位与影响',
    icon: 'ri-global-line',
    color: 'accent',
  },
  {
    slug: 'chang-jian-chang-jing',
    name: '常见场景',
    description: 'NTR作品中常见的情节模式与角色类型',
    icon: 'ri-layout-masonry-line',
    color: 'secondary',
  },
  {
    slug: 'xiang-guan-zuo-pin',
    name: '相关作品与讨论',
    description: '经典NTR作品推荐与圈内话题讨论',
    icon: 'ri-discuss-line',
    color: 'accent',
  },
];